import { COLOR } from 'admin/constants/styles';
import React from 'react';
import styled, { Interpolation } from 'styled-components';
import { InputErrors } from './WithErrors';

type Props = {
  value?: string;
  syncValue?: string;
  innerRef?: React.RefObject<HTMLInputElement>;
  inputStyles?: Interpolation<React.CSSProperties>;
  unit?: string;
  align?: 'left' | 'center' | 'right';
} & Omit<React.ComponentProps<typeof InputErrors>, 'children'> &
  React.InputHTMLAttributes<HTMLInputElement>;

const InnerInput = styled.input.attrs((props) => ({
  type: props.type,
  placeholder: props.placeholder || '',
  size: props.size || 20,
}))<{
  align?: 'left' | 'center' | 'right';
  styles?: Interpolation<React.CSSProperties>;
}>`
  padding: 5px;
  border-radius: 3px;
  border: 1px solid ${COLOR.lightGray};
  outline: none;
  background: none;
  text-align: ${(props) => props.align || 'left'} !important;
  ${({ styles }) => styles}
`;

const Unit = styled.span`
  color: #aaa;
  font-size: 20px;
  font-weight: 500;
  text-align: center;
  margin: 0 8px;
  vertical-align: middle;
`;

const Input = ({
  value,
  syncValue,
  innerRef,
  unit,
  errors,
  inputStyles,
  fullWidth = false,
  ...rest
}: Props) => {
  return (
    <InputErrors errors={errors} fullWidth={fullWidth}>
      <InnerInput
        ref={innerRef}
        defaultValue={value}
        value={syncValue}
        styles={inputStyles}
        {...rest}
      />
      {unit ? <Unit>{unit}</Unit> : null}
    </InputErrors>
  );
};

export default styled(Input)<{ fullWidth?: boolean }>`
  ${({ fullWidth }) => fullWidth && 'width: 100%;'}
`;
